import React, { useState, useMemo } from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import SchedulerPage from './components/SchedulerPage';
import { TeamMember } from './types';
import { calculateOverlap } from './utils/overlapCalculator';
import './App.css';

const App: React.FC = () => {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [selectedSlot, setSelectedSlot] = useState<any>(null);

  const handleAddMember = (member: TeamMember) => {
    setTeamMembers(prev => [...prev, member]);
  };

  const overlaps = useMemo(() => calculateOverlap(teamMembers), [teamMembers]);

  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/scheduler" element={<SchedulerPage />} />
        </Routes>
      </div>    
  );
};

export default App;